module.exports = __webpack_public_path__ + "static/img/posterProduct3.1e97ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posterProduct3.png
// module id = glfb
// module chunks = 2